<template>
  <v-row>
    <v-col
      cols="12"
      class="dropdown-card"
    >
      <v-card id="filter-by-dropdown">
        <v-row>
          <v-col cols="4">
            <FilterByDropdown
              ref="programFilter"
              filter-type="program"
            />
          </v-col>
          <v-col cols="4">
            <FilterByDropdown
              ref="projectFilter"
              filter-type="project"
            />
          </v-col>
          <v-col cols="4">
            <FilterByDropdown
              ref="surveyFilter"
              filter-type="survey"
            />
          </v-col>
          <v-row
            class="filters"
            justify="center"
          >
            <v-btn
              outlined
              small
              @click="reset"
            >
              Clear Filters
            </v-btn>
          </v-row>
        </v-row>
        <v-divider /><br>
        <SurveyResponsesExport />
      </v-card>

      <SurveyFilterOptions :meta-data="metaData" />
      <SurveyResponses :meta-data="metaData" />
    </v-col>
  </v-row>
</template>

<script>
import FilterByDropdown from "@/components/Dashboard/Charts/FilterByDropdown";
import SurveyResponsesExport from "@/components/Dashboard/SurveyResponses/SurveyResponsesExport";
import SurveyFilterOptions from "@/components/Dashboard/SurveyResponses/SurveyFilterOptions";
import SurveyResponses from "@/components/Dashboard/SurveyResponses/SurveyResponses";

import { mapActions, mapState } from "vuex";

export default {
  components: {
    FilterByDropdown,
    SurveyResponsesExport,
    SurveyResponses,
    SurveyFilterOptions
  },
  data() {
    return {
      metaData: {}
    };
  },
  computed: {
    ...mapState({
      selectedSurvey: state => state.survey.selectedSurvey
    })
  },
  watch: {
    selectedSurvey() {
      this.updateMetaDataAndSelectedFilterOptions();
    }
  },
  created() {
    // fetch all
    this.getPrograms();
    this.getProjects();
    this.fetchSurveys();
    this.fetchResponses();
    this.fetchStakeholders();
    this.updateSelectedFilterOptions({}); // reset selectedFilterOptions
    this.updateSelectedSurvey({}); // reset selectedSurvey in dropdown each time stakeholder changes tabs
  },
  methods: {
    ...mapActions("surveyResponseFiltering", [
      "fetchResponses",
      "fetchStakeholders",
      "updateSelectedFilterOptions"
    ]),
    ...mapActions({
      getPrograms: "programs/getPrograms",
      getProjects: "projects/getProjects",
      fetchSurveys: "survey/fetchSurveys",
      updateSelectedSurvey: "survey/updateSelectedSurvey",
      filterProjects: "projects/filterProjects",
      filterSurveys: "survey/filterSurveys"
    }),
    updateMetaDataAndSelectedFilterOptions() {
      this.updateSelectedFilterOptions({});
      if (this.selectedSurvey.survey_metadata) {
        this.metaData = this.selectedSurvey.survey_metadata.meta_data;
      }
    },
    reset() {
      this.$refs.programFilter.clearFilters();
      this.$refs.projectFilter.clearFilters();
      this.$refs.surveyFilter.clearFilters();
      this.updateSelectedSurvey({});
    }
  }
};
</script>

<style scoped>
#filter-by-dropdown {
  padding: 2%;
}
.filters {
  padding-left: 2%;
  padding-right: 1%;
}
</style>
